import { lazyWithReload } from '@shared/utils/lazyWithReload';

/**
 * 라우터 단위 코드 스플리팅.
 * 조문객(부고장 링크)이 받는 기본 번들에는 BugoRouter(부고장·상주 링크)만 싣고,
 * 나머지 영역은 처음 진입할 때 청크로 받는다. 청크 이름은 webpackChunkName 주석으로 고정(빌드 산출물 식별용).
 */
const importStoreRouter = () =>
  import(/* webpackChunkName: "store" */ '@route/StoreRouters/StoreRouter');
const importGiftStoreRouter = () =>
  import(/* webpackChunkName: "gift-store" */ '@route/GiftStoreRouters/GiftStoreRouter');
const importSellerRouter = () =>
  import(/* webpackChunkName: "flower-seller" */ '@route/SellerRouters/SellerRouter');
const importGiftSellerRouter = () =>
  import(
    /* webpackChunkName: "gift-seller" */ '@route/GiftSellerRouters/GiftSellerRouter'
  );
const importGiftBrandRouter = () =>
  import(/* webpackChunkName: "gift-brand" */ '@route/GiftBrandRouters/GiftBrandRouter');
const importAdminRouter = () =>
  import(/* webpackChunkName: "admin" */ '@route/AdminRouter');
const importGiftApiRouter = () =>
  import(/* webpackChunkName: "gift-api" */ '@route/GiftApiRouter');
const importBugoAuthRouter = () =>
  import(/* webpackChunkName: "bugo-auth" */ '@route/BugoRouters/BugoAuthRouter');
const importKakaoCallbackPage = () =>
  import(/* webpackChunkName: "kakao-callback" */ '@shared/page/KakaoCallbackPage');

export const StoreRouterLazy = lazyWithReload(() =>
  importStoreRouter().then((m) => ({ default: m.StoreRouter })),
);
export const GiftStoreRouterLazy = lazyWithReload(() =>
  importGiftStoreRouter().then((m) => ({ default: m.GiftStoreRouter })),
);
export const SellerRouterLazy = lazyWithReload(() =>
  importSellerRouter().then((m) => ({ default: m.SellerRouter })),
);
export const GiftSellerRouterLazy = lazyWithReload(() =>
  importGiftSellerRouter().then((m) => ({ default: m.GiftSellerRouter })),
);
export const GiftBrandRouterLazy = lazyWithReload(() =>
  importGiftBrandRouter().then((m) => ({ default: m.GiftBrandRouter })),
);
export const AdminRouterLazy = lazyWithReload(() =>
  importAdminRouter().then((m) => ({ default: m.AdminRouter })),
);
export const GiftApiRouterLazy = lazyWithReload(() =>
  importGiftApiRouter().then((m) => ({ default: m.GiftApiRouter })),
);
export const BugoAuthRouterLazy = lazyWithReload(() =>
  importBugoAuthRouter().then((m) => ({ default: m.BugoAuthRouter })),
);
export const KakaoCallbackPageLazy = lazyWithReload(() =>
  importKakaoCallbackPage().then((m) => ({ default: m.KakaoCallbackPage })),
);

/**
 * 화환 스토어 청크 선로딩 — 조문객이 화환 버튼에 손을 대는 순간(touchstart/hover/focus) 받기 시작해
 * 실제 클릭 때는 대기가 거의 없게 한다. 모든 조문객에게 미리 내려보내지는 않는다(CDN 전송량 때문).
 */
let storePrefetched = false;
export const prefetchStoreRouter = () => {
  if (storePrefetched) return;
  storePrefetched = true;
  importStoreRouter().catch(() => {
    storePrefetched = false;
  });
};
